export function getFefcoEnums(options) {
    const optionsMap = options.reduce((acc, option) => {
        let key = option.name.slice(0, 2);
        if (acc[key]) {
            acc[key].push(option);
        } else {
            acc[key] = [option];
        }
        return acc;
    }, {})

    return Object.entries(optionsMap).map(([key, options]) => {
        let codeTitle = BX.message('CATALOG_INDIVIDUAL_CODES');
        return {
            label: codeTitle + ` ${key}xx`,
            options
        }
    });
}

export function getBrandCardboardEnums(options, countLayers) {
    if (!countLayers || countLayers === 3) return options;

    return options.filter(option => {
        if (!option.count_layout) return true;

        if (!Array.isArray(option.count_layout)) {
            return option.count_layout === countLayers;
        }

        return !!option.count_layout.includes(countLayers);
    })
}